import SearchBoxMultiselect from "@/components/ui/custom/searchBoxMultiselect/searchBoxMultiselect";
import { FilterButtonsProps } from "components/Explore/FilterButtons";

interface FilterCapsulesProps extends FilterButtonsProps {
  render: boolean;
}

export default function FilterCapsules(props: FilterCapsulesProps) {
  if (!props.render) return null;
  return (
    <div className="flex gap-2">
      <SearchBoxMultiselect
        className="min-h-[42px] rounded-full pl-4"
        selectedFilterTagValues={props.selectedFilterTagValues}
        setSelectedFilterTagValues={props.setSelectedFilterTagValues}
        tags={props.tags}
        showBadge={false}
        placeholder="Filtrar"
      />
    </div>
  );
}
